export default __webpack_public_path__ + "static/media/gas.8dba9d62.png";